import React, { useMemo } from 'react';
import { makeStyles } from '@material-ui/core';
import { CircularProgressWithLabel } from '../SessionUploadButton';
import { TLabelTask } from './SessionLabelTask';

const useStyles = makeStyles(() => ({
  circularProgress: {
    display: 'inline-flex',
    width: '42px',
    height: '42px',
    backgroundColor: '#f5f6fa',
    borderRadius: '24px',
    verticalAlign: 'bottom',
    margin: '0px 4px',
  },
}));

type Props = {
  task: TLabelTask;
  lastLabeledFrameId: number;
};

const LabelCircularProgress = React.memo((props: Props) => {
  const classes = useStyles();

  const { task, lastLabeledFrameId } = props;

  const percCompleted: number = useMemo(
    () =>
      Math.max(
        0,
        Math.min(100, Math.floor(((lastLabeledFrameId - task.startFrame) / (task.endFrame - task.startFrame)) * 100))
      ),
    [lastLabeledFrameId, task]
  );

  return (
    <div className={classes.circularProgress}>
      <CircularProgressWithLabel color={percCompleted === 100 ? 'secondary' : 'primary'} value={percCompleted} />
    </div>
  );
});

export default LabelCircularProgress;
